import UdeskLocales from 'UdeskLocales';

export const LanguageEnum = {
    All: 0,
    ZH: 1,
    EN: 2,
    ZH_HK: 3,
    TI: 4,
    MS: 5,
    ID: 6,
    KR: 7,
    FI: 8,
    JP: 9,
    FR: 10,
    SP: 11,
    RU: 12,
    AR: 13,
    TU: 14,
    VI: 15,
    PT: 16,
    DE: 17,
    IT: 18,
    PL: 19,
    FIL: 20,
    HL: 21,
    JT: 22,
    ME: 23,
    GR: 24,
    EN_US: 25,
    IND: 26,
    ZH_TW: 27,
    KM: 28,
    EN_CA: 29,
    EN_AF: 30,
    KK: 31,
    UR: 57,
};

export const getLanguage = (language: number) => {
    const LanguageMap = {
        [LanguageEnum.All]:
            /* 所有语言 */ UdeskLocales['current'].components.languageSelect.const.allLanguages,
        [LanguageEnum.ZH]:
            /* 中文 */ UdeskLocales['current'].components.languageSelect.const.chinese,
        [LanguageEnum.EN]:
            /* 英文 */ UdeskLocales['current'].components.languageSelect.const.english,
        [LanguageEnum.ZH_HK]:
            /* 粤语 */ UdeskLocales['current'].components.languageSelect.const.cantonese,
        [LanguageEnum.TI]: /* 泰语 */ UdeskLocales['current'].components.languageSelect.const.thai,
        [LanguageEnum.MS]:
            /* 马来语 */ UdeskLocales['current'].components.languageSelect.const.malay,
        [LanguageEnum.ID]:
            /* 印尼语 */ UdeskLocales['current'].components.languageSelect.const.indonesian,
        [LanguageEnum.KR]:
            /* 韩语 */ UdeskLocales['current'].components.languageSelect.const.korean,
        [LanguageEnum.FI]:
            /* 菲律宾语 */ UdeskLocales['current'].components.languageSelect.const.filipino,
        [LanguageEnum.JP]:
            /* 日语 */ UdeskLocales['current'].components.languageSelect.const.japanese,
        [LanguageEnum.FR]:
            /* 法语 */ UdeskLocales['current'].components.languageSelect.const.french,
        [LanguageEnum.SP]:
            /* 西班牙语 */ UdeskLocales['current'].components.languageSelect.const.spanish,
        [LanguageEnum.RU]:
            /* 俄语 */ UdeskLocales['current'].components.languageSelect.const.russian,
        [LanguageEnum.AR]:
            /* 阿拉伯语 */ UdeskLocales['current'].components.languageSelect.const.arabic,
        [LanguageEnum.TU]:
            /* 土耳其语 */ UdeskLocales['current'].components.languageSelect.const.turkish,
        [LanguageEnum.VI]:
            /* 越南语 */ UdeskLocales['current'].components.languageSelect.const.vietnamese,
        [LanguageEnum.PT]:
            /* 葡萄牙语 */ UdeskLocales['current'].components.languageSelect.const.portuguese,
        [LanguageEnum.DE]:
            /* 德语 */ UdeskLocales['current'].components.languageSelect.const.german,
        [LanguageEnum.IT]:
            /* 意大利语 */ UdeskLocales['current'].components.languageSelect.const.italian,
        [LanguageEnum.PL]:
            /* 波兰语 */ UdeskLocales['current'].components.languageSelect.const.polish,
        [LanguageEnum.FIL]:
            /* 芬兰语 */ UdeskLocales['current'].components.languageSelect.const.finnish,
        [LanguageEnum.HL]:
            /* 荷兰语 */ UdeskLocales['current'].components.languageSelect.const.dutch,
        [LanguageEnum.JT]:
            /* 捷克语 */ UdeskLocales['current'].components.languageSelect.const.czech,
        [LanguageEnum.ME]:
            /* 孟加拉语 */ UdeskLocales['current'].components.languageSelect.const.bengali,
        [LanguageEnum.GR]:
            /* 希腊语 */ UdeskLocales['current'].components.languageSelect.const.greek,
        [LanguageEnum.IND]:
            /* 印地语 */ UdeskLocales['current'].components.languageSelect.const.hindi,
        [LanguageEnum.ZH_TW]:
            /* 中文台湾 */ UdeskLocales['current'].components.languageSelect.const.chineseTaiwan,
        [LanguageEnum.KM]:
            /* 柬埔寨语 */ UdeskLocales['current'].components.languageSelect.const.cambodian,
        [LanguageEnum.EN_US]:
            /* 美式英语 */ UdeskLocales['current'].components.languageSelect.const.americanEnglish,
        [LanguageEnum.EN_CA]:
            /* 加拿大英语 */ UdeskLocales['current'].components.languageSelect.const
                .canadianEnglish,
        [LanguageEnum.EN_AF]:
            /* 非洲英语 */ UdeskLocales['current'].components.languageSelect.const.africanEnglish,
        [LanguageEnum.KK]: /* 哈萨克语 */UdeskLocales['current'].components.languageSelect.const.kazakh,
        [LanguageEnum.UR]: /* 乌尔都语 */UdeskLocales['current'].components.languageSelect.const.urdu,
    };

    return LanguageMap[language] ?? '-';
};
